// Utils
import { setDnd3dEffectsEnabledLocalStorage } from './interfaceSettingsService';
import { clearDropStateSingleton } from '../../../../element/dnd/dropStateSingleton';

// Constants
import { DND_3D_EFFECTS_SET } from './interfaceSettingsConstants';

export const setDnd3dEffects = (enabled) => {
    setDnd3dEffectsEnabledLocalStorage(enabled);
    clearDropStateSingleton(true);

    return {
        type: DND_3D_EFFECTS_SET,
        enabled,
    };
};
